var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRearrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "18px",
    viewBox: "0 0 10 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6A7A8899-9ED2-4DFB-ABCA-16F4F3A8977D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/rearrange",
    fill: "#DDDDDD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.77631579,
    cy: 1.77631579,
    r: 1.77631579
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.81578947,
    cy: 1.77631579,
    r: 1.77631579
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.77631579,
    cy: 9,
    r: 1.77631579
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.81578947,
    cy: 9,
    r: 1.77631579
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.77631579,
    cy: 16.2236842,
    r: 1.77631579
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.81578947,
    cy: 16.2236842,
    r: 1.77631579
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRearrange);
export default __webpack_public_path__ + "static/media/rearrange.5c799afba2ba19168ee4e9a3f141f968.svg";
export { ForwardRef as ReactComponent };